import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Table, IconButton } from 'react-toolbox'
import CSSModules from 'react-css-modules'
import _ from 'lodash'

import ConfigValidationTooltip from 'components/custom/ConfigValidationTooltip/index'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import ConfigTable from 'components/custom/ConfigTable/index'

import styles from './styles.scss'

import {TableCell} from 'react-toolbox/lib/table'

class MemoryConfigItem extends Component {
  componentDidMount() {
    this.props.curValues.forEach(value => {
      if (!this.props.curValue.clock) {
        this.props.onClockChange(value, this.props.curValue.minClock)
      }
    })
  }

  shouldComponentUpdate(props) {
    if (props.curPart.length !== this.props.curPart.length) {
      this.props.onClockChange(this.props.curValue, this.props.curValue.clock)
    }

    return true
  }

  /**
   *
   * Generate the parts with existing data and the rvl icon and delete icon.
   * rvl section will show an exclaimation mark if the part is non-rvl.
   *
   * @param {Object[]} parts
   * @returns {Object[]} new array of parts with delete icon and rvl icon
   * @memberof MemoryConfigItem
   */
  generatePart(parts) {
    return parts.map(({rvlId, ...part}) => {
      return {
        ...part,
        rvlId: rvlId ? <IconButton icon='check' className={styles['rvlIcon']} theme={styles} /> :
                       <IconButton icon='close' className={styles['nonRvlIcon']} theme={styles} />,
      }
    })
  }

  render() {
    const {
      config,
      index,
      curPart,
      filterPairs,
      initFilters,
      onDeletePart,
      onTogglePopup,
      onUpdateCurConfig,
      setIsAddPart,
    } = this.props
    const configTitle=`Configuration: ${config.type}, ${config.organization}, ${config.density}`
    let configSource = this.generatePart(curPart)

    // const PartModel = {
    //   vendorName: {type: String, title: 'Vendor Name'},
    //   partNumber: {type: String, title: 'Part Number'},
    //   rvlId: {type: Number, title: 'RVL'},
    // }

      const partModelTableHeadContent = {
          vendorName: (<TableCell key={0}>Vendor Name</TableCell>),
          partNumber: (<TableCell key={1}>Part Number</TableCell>),
          rvlId: (<TableCell key={2}>RVL</TableCell>),
      }

    let initFilterObj = {}
    for (const filterType in filterPairs) {
      if (!filterPairs.hasOwnProperty(filterType)) continue

      const filterArr = _.cloneDeep(filterPairs[filterType])
      // exclude the last element (name of the filter)
      filterArr.pop()

      initFilterObj[filterType] = filterArr.map(filter => filter.value)
    }

    return (
      <div key={index}>
        <div>
          <span styleName='configTitle'>{ configTitle }</span>
          <ConfigValidationTooltip
            isRisk={curPart ? curPart[0].risk === 'Risk' : false}
          />
        </div>
        <FormTitle title={'Clock Value'} styleName='clockInput'>
          { config.clock }
        </FormTitle>
        <ConfigTable
          tableHeadContent={partModelTableHeadContent}
          configSource={ configSource }
          createAddBtn={ true }
          filters={ initFilterObj }
          initFilters={ initFilters }
          btnText={'Add Part...'}
          configKeys={['config']}
          onDeletePart={ onDeletePart }
          onTogglePopup={ onTogglePopup }
          onUpdateCurConfig={ onUpdateCurConfig }
          setIsAddPart={setIsAddPart}
          deletable
        />
      </div>
    )
  }
}

MemoryConfigItem.propTypes = {
  index: PropTypes.number.isRequired,
  curPart: PropTypes.array.isRequired,
  curValues: PropTypes.array.isRequired,
  curValue: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,

  onClockChange: PropTypes.func.isRequired,
  onTogglePopup: PropTypes.func.isRequired,
  onDeletePart: PropTypes.func.isRequired,
  onUpdateCurConfig: PropTypes.func.isRequired,
}

export default CSSModules(MemoryConfigItem, styles)
